export const modalBus = $({});

modalBus.on('callModal', (ev, dataAction) => {
  import('./modal').then(({ callModal }) => {
    callModal(dataAction);
  });
});
